import axios from "axios";

export const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || "https://greenberry-verad29.fly.dev";
const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  timeout: 120000,
});

// Neutral service names (no AI provider exposure)
export const researchMetadataService = {
  async search(q = "") {
    const { data } = await apiClient.get("/research-search", { params: { q } });
    return data;
  },
};

export const analysisService = {
  async generateDesignAnalysis(payload) {
    const { data } = await apiClient.post("/analyze-design", payload);
    return data;
  },
};

export const syntheticUserService = {
  async generateCardGameOutput(payload) {
    const { data } = await apiClient.post("/generate-card-game-output", payload);
    return data;
  },
};

// Phase 5, per-section feedback loop for GooseBerry outputs.
export const feedbackService = {
  async submitSectionFeedback(payload) {
    const { data } = await apiClient.post("/gooseberry/feedback", payload);
    return data;
  },
  async listFeedback(runId) {
    const { data } = await apiClient.get("/gooseberry/feedback", { params: { runId } });
    return data;
  },
  async regenerateWithCorrections(payload) {
    const { data } = await apiClient.post(
      "/gooseberry/regenerate-with-corrections",
      payload
    );
    return data;
  },
};
